import { Group, Paper, PaperProps, Stack, Text, Title } from "@mantine/core"
import { IconArrowRight } from "@tabler/icons-react"

import styles from "./StatsCard.module.css"

export type StatsCardProps = {
  icon?: React.ReactNode
  description: string | React.ReactNode
  value: string
  arrow?: boolean
  onClick?: () => void
  unit?: string
} & Omit<PaperProps, "onClick">

export const StatsCard = ({
  icon,
  value,
  description,
  onClick,
  arrow = true,
  unit,
  ...props
}: StatsCardProps) => {
  return (
    <Paper onClick={onClick} className={styles.container} {...props}>
      <Group mb="md">{icon}</Group>
      <Stack gap={0}>
        <Text className={styles.text}>{description}</Text>
        <Group gap={3} align="baseline">
          <Title order={2} fw="bold" className={styles.text}>
            {value}
          </Title>
          {unit && (
            <Text fw="bold" c="dimmed" className={styles.text}>
              {unit}
            </Text>
          )}
        </Group>
      </Stack>
      {arrow && (
        <div className={styles.hoverArrow}>
          <IconArrowRight size={24} className={styles.text} />
        </div>
      )}
    </Paper>
  )
}
